import { useContext } from "solid-js";
import { IntlContext } from "./provider";
const useIntl = () => {
    const intl = useContext(IntlContext);
    if (!intl) {
        throw new ReferenceError("[solid-intl]: Have you forgot to wrap your application with <IntlProvider /> ?");
    }
    return intl;
};
export default useIntl;
